export default __webpack_public_path__ + "static/media/ganaderiaAlpaquera.7bb1941e.jpg";